import { WORKFLOW_MESSAGE_TYPE_EMAIL } from 'Api/beAutomationApi'
import { modalEmailMessagesState } from 'Hooks/useModalEmailMessages/useModalEmailMessages'
import { modalSmsMessagesState } from 'Hooks/useModalSmsMessages/useModalSmsMessages'
import {
  Button,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { modalUsedMessageState } from 'Pages/Workflow/recoil/state/modals'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

export const ModalStepThirdWorkflowMessageUsed = ({
  show,
  handleCancel,
  handleConfirm,
  name
}) => {
  const intl = useIntl()
  const setModalEmailState = useSetRecoilState(modalEmailMessagesState)
  const setModalSmsState = useSetRecoilState(modalSmsMessagesState)
  const setModalStepThirdWorkflowMessageUsed = useSetRecoilState(
    modalUsedMessageState
  )
  const { droppableId, type } = useRecoilValue(modalUsedMessageState)

  const handleOpen = () => {
    if (type === WORKFLOW_MESSAGE_TYPE_EMAIL) {
      setModalEmailState((prev) => ({
        ...prev,
        show: true,
        droppableId
      }))
    } else {
      setModalSmsState((prev) => ({
        ...prev,
        show: true,
        droppableId
      }))
    }
    // chiudo questa modale
    setModalStepThirdWorkflowMessageUsed((prev) => ({
      ...prev,
      show: false
    }))
  }

  return (
    <Modal
      data-mu-test='modal-endStepThirdWorkflow'
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.AutomationWorkflow.WarningSelectMessageTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.AutomationWorkflow.WarningSelectMessage'
          })}
          {` (${name})`}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={handleOpen}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.SelectAnotherMessage' })}
        </Button>
        <Button
          kind='primary'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.CreateCopy'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalStepThirdWorkflowMessageUsed.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  name: PropTypes.string
}
